import { useEffect, useState } from "react";
import { currentUserLocalStorage } from "services/storage/general";

const useTeacherName = () => {
	const [teacherName, setTeacherName] = useState("");
	useEffect(() => {
		const currentUser = currentUserLocalStorage.get();
		if (!currentUser) return;
		setTeacherName(currentUser.name);
	}, []);
	return teacherName;
};

export default useTeacherName;
